import { Charts } from './Charts';
import MilitaryChartsDataProvider from './contexts/MilitaryChartsDataContext';

const MilitaryWrapper = () => {
    return (
        <MilitaryChartsDataProvider>
            <Charts />
        </MilitaryChartsDataProvider>
    );
};

export default MilitaryWrapper;
